;(function() {

    var 
    
    // The modal popup for the image matrix details.
    $modal = null,
    $modal_body = null,


    //
    //init
    //
    init = function() {
        if ($('.layout-home').length > 0) {

            //get the popup
            $modal = $('.modal-matrix-detail');
            $modal_body = $modal.find('.modal-body');


            // setup matrix image click to show full popup
            $('.matrix-image').on('click', function() {
                showMatrixPopup($(this));                
            });
                

        }
    },


    //
    // Show the flag detail for the image matrix
    //
    showMatrixPopup = function($img) {
        //set the loading message
        $modal_body.html("<div class='well'>Loading . . .</div>");

        //show it
        $modal.modal('show');

        //get the flag id
        var flag_id = $img.attr('data-flag-id');

        //get the url.  NOTE:  This is the same mechanism as the gallery detail popup
        var url = '/gallery/detailPopup/' + flag_id;

        // get the detail content
        $.get(url, function(res) {
            $modal_body.html(res);

            // setup audio link click
            adc.gallery_detail.setupAudioLinkClick();

            // load the AddThis share buttons
            adc.gallery_detail.loadShareButtons();
        });
        
    };


    //call init
    $(document).ready(init);

})();